
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic03 as ObiLogic03Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-03.js';
 
 
 

 
 export const ObiLogic03 = createComponent({
   react: React,
   tagName: 'obi-logic-03',
   elementClass: ObiLogic03Element,
   events: {
     
   }
  });
 
 